<template>
  <div>
    <el-select v-model="_id" class="mr-3" placeholder="機台編號" clearable @clear="onClear" @change="onSelect">
      <el-option v-for="item in mvms" :key="item.id" :label="item.AssetNo" :value="item.id" />
    </el-select>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getMvmSelect } from '@/api/mvms';
export default {
  computed: {
    ...mapGetters(['company']),
    _id: {
      get() {
        return this.id;
      },
      set(val) {
        this.$emit('update:id', val);
      },
    },
  },
  props: {
    companyId: {
      default: null,
    },
    clientId: {
      default: null,
    },
    id: {
      default: null,
    },
    show_all_mvm: {
      default: false,
    },
  },
  data() {
    return {
      mvms: [],
      uid: null,
      condition: {
        company_id: this.companyId,
        client_id: null,
        show_all_mvm: false,
      },
    };
  },
  watch: {
    async companyId() {
      this.condition.company_id = this.companyId;
      this._id = null;
      this.onSelect();
      this.mvms = await getMvmSelect(this.condition);
    },
    async clientId() {
      this.condition.client_id = this.clientId;
      this._id = null;
      this.onSelect();
      this.mvms = await getMvmSelect(this.condition);
    },
    async show_all_mvm() {
      this.condition.show_all_mvm = this.show_all_mvm;
      this._id = null;
      this.onSelect();
      this.mvms = await getMvmSelect(this.condition);
    },
  },

  async created() {
    this.mvms = await getMvmSelect(this.condition);
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    },
    onClear() {
      this._id = null;
      this.onSelect();
    },
  },
};
</script>
